<template>
    <div class="form-group no-margin row">
        <div class="col-auto">
            <label class="col-form-label">{{ label }}</label>
        </div>
        <section class="col-auto" v-for="range in ranges" :value="selected">
            <div class="block" @change="setCycle()">
                <b-radio v-model="selected"
                    name="name"
                    class="custom-control-inline"
                    :value="range.value">
                    {{range.text}}
                </b-radio>
            </div>
        </section>
    </div>
</template>

<script>
import {reactive, ref, computed, watch, onMounted, onUnmounted} from '@vue/composition-api'
// import Datepicker from 'vuejs-datepicker'
import moment from 'moment';

export default {
    data() {
        return {
            selected: "day"
        }
    },
    props: {
        data: {},
        ranges: {
          type:Array,
          default:() => [
            {value:'day', text:'일간'},
            // {value:'week', text:'주간'},
            {value:'month', text:'월간'},
            // {value:'year', text:'연간'},
          ]
        },
        label: "",
    },


    // components: {Datepicker},
    setup(props, context) {

        return {
          ...actions(props.data, context)
        }
    }
}

function actions(data, context) {
  function setCycle() {
    data.params.cycleType = this.selected;
  }

  return {setCycle}
}
</script>
